<template>
  <template v-if="$page">
    <section class="section -less-pad -center">
      <h1 class="section__header" v-reveal>{{ $page.header.title }}</h1>
      <p class="section__text" v-reveal="{ delay: 200 }">{{ $page.header.description }}</p>
      <LangRouterLink
        :to="{ name: 'soumission' }"
        class="button -right section__button"
        v-reveal="{ delay: 250 }"
      >
        {{ $page.header.btn_text }}
        <div class="button__icon">
          <Icon id="arrow" />
        </div>
      </LangRouterLink>
    </section>
    <section class="section voyages">
      <div class="voyages__filters">
        <div class="voyages__filters-greens">
          <div class="voyages__filter -green" @click="filterPlane = !filterPlane">
            <div class="voyages__filter-label">
              <div class="voyages__filter-checkbox">
                <Icon id="checkmark" v-if="filterPlane" />
              </div>
              {{ $t('trips.type.plane') }}
            </div>
            <Icon id="avion" />
          </div>
          <div class="voyages__filter -green" @click="filterBus = !filterBus">
            <div class="voyages__filter-label">
              <div class="voyages__filter-checkbox">
                <Icon id="checkmark" v-if="filterBus" />
              </div>
              {{ $t('trips.type.bus') }}
            </div>
            <Icon id="autobus" />
          </div>
        </div>
        <div class="voyages__filter">
          <select v-model="filterZone">
            <option selected :value="0">{{ $t('trips.type.all') }}</option>
            <option v-for="option in options" :key="`zone-${option.value}`" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="voyages__index">
        <div v-if="!currentPage.length" class="events__empty">
          <h2 class="section__title">{{ $t('trips.noResult') }}</h2>
          <p class="section__p">{{ $t('trips.noResultHelp') }}</p>
          <!-- <button class="button -red" @click="resetFilters"> {{ $page.filters.reset }}</button> -->
        </div>
        <transition-group name="list">
          <VoyageCard
            v-for="voyage in currentPage"
            :key="`card-${voyage.id}`"
            :voyage="voyage"
            :name="voyage.name"
            class="card-voyage"
            :description="voyage.short_description || 'short_description'"
          />
          <AdCard :ads="$beet?.ads?.site?.voyages.listing ?? []" key="card-ad" />
        </transition-group>
      </div>

      <button
        class="voyages__more button -right"
        @click="loadMore"
        :disabled="page * pageSize >= destinations.length"
      >
        {{ $t('trips.seeMore') }}
        <span class="button__icon">
          <Icon id="plus" />
        </span>
      </button>
    </section>

    <AdBanner :ads="$beet?.ads?.site?.voyages.middle ?? []" />

    <PageBuilder :sections="$page.sections" />
  </template>

  <template v-else>
    <Loader />
  </template>
</template>

<script>
import Loader from '@/App.vue'
import AdCard from '@/components/cards/AdCard.vue'
import VoyageCard from '@/components/cards/VoyageCard.vue'
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import PageBuilder from '@/components/PageBuilder.vue'
import AdBanner from '@/components/sections/AdBanner.vue'
import { setMeta } from '@/helpers/metaHelpers'

export default {
  name: 'Voyages',
  components: { AdCard, AdBanner, Icon, LangRouterLink, Loader, PageBuilder, VoyageCard },
  beetPage: 'destinations',
  data() {
    return {
      page: 1,
      pageSize: 12,
      filterPlane: false,
      filterBus: false,
      filterZone: 0,
    }
  },
  watch: {
    $page(to) {
      setMeta(to.seo)
    },
    filterPlane(to) {
      this.$store.state.filterPlane = to
    },
    filterBus(to) {
      this.$store.state.filterBus = to
    },
    filterZone(to) {
      this.$store.state.filterZone = to
    },
  },
  beforeMount() {
    if (this.$page) setMeta(this.$page.seo)
  },
  mounted() {
    this.filterPlane = this.$store.state.filterPlane
    this.filterBus = this.$store.state.filterBus
    this.filterZone = this.$store.state.filterZone || 0
  },
  methods: {
    loadMore() {
      this.page++
    },
  },
  computed: {
    options() {
      if (this.$beet.destinations_zones) {
        return Object.values(this.$beet.destinations_zones).map((zone) => {
          return {
            value: zone.id,
            label: zone.name,
          }
        })
      }
      return []
    },
    destinations() {
      if (!this.$beet.destinations) return []
      const arr = this.$beet.destinations

      let data = arr.toSorted((a, b) => {
        const nameA = a.name.toLowerCase().normalize('NFD')
        const nameB = b.name.toLowerCase().normalize('NFD')
        if (nameA < nameB) return -1
        if (nameA > nameB) return 1
        return 0
      })
      if (this.filterBus && this.filterPlane) return data
      if (this.filterBus) data = data.filter(({ type }) => type === 'bus')
      if (this.filterPlane) data = data.filter(({ type }) => type === 'plane')
      if (this.filterZone) data = data.filter(({ zone_id }) => Number(zone_id) === this.filterZone)
      return data
    },
    results() {
      return this.destinations.length
    },
    currentPage() {
      return this.destinations.slice(0, this.page * this.pageSize)
    },
  },
}
</script>
